module.exports = __webpack_public_path__ + "static/img/back.5d1ad7e2.png";